// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select_grid-row-2__vqKEs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
}

.Select_vm-20__zzRX6 {
  margin: 20px 0;
}

.Select_divider-0__3cZTy {
  width: 100%;
  height: 1px;
  background-color: #d0d7dd;
}

.Select_rel__isPh1 {
  position: relative;
}

.Select_flex__8DDnx {
  display: flex;
}

.Select_jcc__D8hG4 {
  justify-content: center !important;
}

.Select_wrapper__2Cvke {
  max-width: 416px;
}
.Select_wrapper_fullwidth__ywQi3 {
  max-width: none;
}

.Select_select__0ysHQ {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 416px;
  height: 40px;
  padding: 0 35px 0 12px;
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid #E1E5EA;
  font-size: 14px;
  color: #7d838a;
  cursor: pointer;
}
.Select_select_disabled__2iWFM {
  color: #aab1ba;
  background-color: #e9eaea;
  cursor: default;
}
.Select_select_disabled__2iWFM .Select_select__value__05k-l::after {
  background: linear-gradient(90deg, rgba(163, 224, 219, 0.18) -10%, rgb(233, 234, 234) 50%);
}
.Select_select_short__r3vh9 {
  width: 186px;
}
.Select_select_invalid__LR0EQ {
  border-color: #ee505a;
}
.Select_select_fullwidth__P1Jp\\+ {
  width: 100%;
}
.Select_select_fullwidth__P1Jp\\+ input {
  width: 100%;
}
.Select_select__value__05k-l {
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  transition: 0.2s;
}
.Select_select__value_active__nr5x0 {
  color: #000000;
}
.Select_select__value__05k-l::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: 15px;
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) -10%, rgb(255, 255, 255) 50%);
  pointer-events: none;
  transition: 0.2s;
}
.Select_select__arrow__ur\\+QJ {
  position: absolute;
  right: 0px;
  top: -5px;
  padding: 12px 12px;
  color: #000000;
  transition: 0.3s;
}
.Select_select__arrow_expanded__Cv179 {
  transform: rotate(180deg);
  color: #000000;
}
.Select_select__options__Fu7zU {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 100%;
  left: 0px;
  width: 100%;
  max-height: 168px;
  z-index: -1;
  overflow-y: scroll;
  border-radius: 4px;
  background-color: #fff;
  transition: 0.2s;
}
.Select_select__options_expanded__Rpi2a {
  top: calc(100% + 5px);
  z-index: 4;
  border: 1px solid rgba(214, 214, 215, 0.5);
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.08);
}
.Select_select__option__SAE0G {
  position: relative;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: 0px 12px;
  max-height: 0px;
  overflow: hidden;
  transition: 0.2s;
  color: #000000;
  cursor: pointer;
}
.Select_select__option-text__tbioK {
  white-space: nowrap;
  overflow: hidden;
  transition: 0.2s;
}
.Select_select__option-text__tbioK::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: 25px;
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) -10%, rgb(255, 255, 255) 50%);
  pointer-events: none;
  transition: 0.2s;
  opacity: 1;
}
.Select_select__option_expanded__MxQdN {
  padding: 6px 12px;
  max-height: none;
}
.Select_select__option_expanded__MxQdN:first-child {
  padding-top: 12px;
}
.Select_select__option_expanded__MxQdN:last-child {
  padding-bottom: 12px;
}
.Select_select__option__SAE0G:hover {
  background-color: rgba(214, 214, 215, 0.5);
}
.Select_select__option__SAE0G:hover .Select_select__option-text__tbioK::after {
  opacity: 0;
}
.Select_select__error__OOYM- {
  margin-top: 4px;
  margin-bottom: -10px;
  font-size: 14px;
  line-height: 22px;
  color: #ee505a;
}`, "",{"version":3,"sources":["webpack://./src/assets/helpers/grid.scss","webpack://./src/components/ui/Form/Select/Select.module.scss","webpack://./src/assets/helpers/colors.scss","webpack://./src/assets/helpers/constants.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;ACAF;;ADIA;EACE,cAAA;ACDF;;ADKA;EACE,WAAA;EACA,WAAA;EACA,yBEVM;ADQR;;ADMA;EACE,kBAAA;ACHF;;ADMA;EACE,aAAA;ACHF;;ADMA;EACE,kCAAA;ACHF;;AAxBA;EACE,gBEFU;AF6BZ;AAzBE;EACE,eAAA;AA2BJ;;AAvBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YEdU;EFeV,YAAA;EACA,sBAAA;EACA,yBCjBM;EDkBN,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,cCHM;EDIN,eAAA;AA0BF;AAxBE;EACE,cCTQ;EDUR,yBCtBI;EDuBJ,eAAA;AA0BJ;AAvBM;EACE,0FCsCsB;ADb9B;AApBE;EACE,YAAA;AAsBJ;AAnBE;EACE,qBCFE;ADuBN;AAlBE;EACE,WAAA;AAoBJ;AAnBI;EACE,WAAA;AAqBN;AAjBE;EACE,kBAAA;EAMA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAcJ;AApBI;EACE,cCjCK;ADuDX;AAfI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uFCDgB;EDEhB,oBAAA;EACA,gBAAA;AAiBN;AAbE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EAEA,cCvDI;EDwDJ,gBAAA;AAcJ;AAZI;EACE,yBAAA;EACA,cChEK;AD8EX;AAVE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EAEA,SAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EAEA,kBAAA;EAQA,kBAAA;EACA,sBAAA;EACA,gBAAA;AAGJ;AADI;EACE,qBAAA;EACA,UAAA;EACA,0CAAA;EACA,2CAAA;AAGN;AACE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EAEA,cC7GO;ED8GP,eAAA;AAAJ;AAEI;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;AAAN;AAEM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uFC9Ec;ED+Ed,oBAAA;EACA,gBAAA;EACA,UAAA;AAAR;AAII;EACE,iBAAA;EACA,gBAAA;AAFN;AAIM;EACE,iBAAA;AAFR;AAKM;EACE,oBAAA;AAHR;AAOI;EACE,0CC1Fe;ADqFrB;AAQQ;EACE,UAAA;AANV;AAYE;EACE,eAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC/IE;ADqIN","sourcesContent":["// grid\n.grid-row-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 24px;\n}\n\n// paddings, margins\n.vm-20 {\n  margin: 20px 0;\n}\n\n// elements\n.divider-0 {\n  width: 100%;\n  height: 1px;\n  background-color: $gray5;\n}\n\n// helpers\n.rel {\n  position: relative;\n}\n\n.flex {\n  display: flex;\n}\n\n.jcc {\n  justify-content: center!important;\n}","@import '../../../../assets/helpers/index.scss';\n\n.wrapper {\n  max-width: $formWidth;\n\n  &_fullwidth {\n    max-width: none;\n  }\n}\n\n.select {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: $formWidth;\n  height: 40px;\n  padding: 0 35px 0 12px;\n  background-color: $white;\n  border-radius: 12px;\n  border: 1px solid $selectBorderColor;\n  font-size: 14px;\n  color: $smallText;\n  cursor: pointer;\n\n  &_disabled {\n    color: $secondaryColor;\n    background-color: $gray2;\n    cursor: default;\n    .select__value {\n\n      &::after {\n        background: $gradientPlaceholderDisabled;\n      }\n    }\n  }\n\n  &_short {\n    width: 186px;\n  }\n\n  &_invalid {\n    border-color: $danger;\n  }\n\n  &_fullwidth {\n    width: 100%;\n    input {\n      width: 100%;\n    }\n  }\n\n  &__value {\n    position: relative;\n\n    &_active {\n      color: $headText;\n    }\n    \n    white-space: nowrap;\n    overflow: hidden;\n    transition: 0.2s;\n\n    &::after {\n      content: \"\"; \n      position: absolute;\n      right: 0;\n      bottom: 0;\n      width: 15px;\n      height: 100%;\n      background: $gradientPlaceholder; \n      pointer-events: none;\n      transition: 0.2s;\n    }\n  }\n\n  &__arrow {\n    position: absolute;\n    right: 0px;\n    top: -5px;\n    padding: 12px 12px;\n\n    color: $black;\n    transition: 0.3s;\n\n    &_expanded {\n      transform: rotate(180deg);\n      color: $headText;\n    }\n  }\n\n  &__options {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n\n    top: 100%;\n    left: 0px;\n    width: 100%;\n    max-height: 168px;\n    z-index: -1;\n\n    overflow-y: scroll;\n    //-ms-overflow-style: none; /* IE and Edge */\n    //scrollbar-width: none; /* Firefox */\n\n    &::-webkit-scrollbar {\n      //display: none;\n    }\n\n    border-radius: 4px;\n    background-color: #fff;\n    transition: 0.2s;\n\n    &_expanded {\n      top: calc(100% + 5px);\n      z-index: 4;\n      border: 1px solid $borderOpacityColor;\n      box-shadow: 0px 1px 6px $boxShadowColor;\n    }\n  }\n\n  &__option {\n    position: relative;\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    padding: 0px 12px;\n    max-height: 0px;\n    overflow: hidden;\n    transition: 0.2s;\n\n    color: $headText;\n    cursor: pointer;\n    \n    &-text {\n      white-space: nowrap;\n      overflow: hidden;\n      transition: 0.2s;\n\n      &::after {\n        content: \"\"; \n        position: absolute;\n        right: 0;\n        bottom: 0;\n        width: 25px;\n        height: 100%;\n        background: $gradientPlaceholder; \n        pointer-events: none;\n        transition: 0.2s;\n        opacity: 1;\n      }\n    }\n\n    &_expanded {\n      padding: 6px 12px;\n      max-height: none;\n\n      &:first-child {\n        padding-top: 12px;\n      }\n\n      &:last-child {\n        padding-bottom: 12px;\n      }\n    }\n\n    &:hover {\n      background-color: $borderOpacityColor;\n\n      & .select__option-text {\n        &::after {\n          opacity: 0;\n        }\n      }\n    }\n  }\n\n  &__error {\n    margin-top: 4px;\n    margin-bottom: -10px;\n    font-size: 14px;\n    line-height: 22px;\n    color: $danger;\n  }\n}\n","//  Color scheme\n$white: #ffffff;\n$whiteGray: #f2f4f7;\n$halfGray: #f5faff;\n$grayWhite: #e7e9eb;\n$gray2: #e9eaea;\n$gray5: #d0d7dd;\n$gray7: #d1d5df;\n$gray8: #f4f4f4;\n$gray13: #f8f9fa;\n$gray12: #e0e1e9;\n$gray9: #cbcdd0;\n$gray10: #E1E5EA;\n$gray11: #1F1F22;\n$shadowGray: #d5d5d6;\n$shadowGray2: rgba(25, 27, 35, 0.15);\n$gray3: #c4c4c4;\n$lightGray: #aab1ba;\n$gray4: #878b90;\n$gray6: #7d838a;\n$gray14: #F6F6F6;\n$grayAsphalt: #344045;\n$gray: #808185;\n$textGray: #000000;\n$black1: #0b1f33;\n$black2: #333F48;\n\n$black: #000000;\n\n$lightGreen: #a4eedc;\n$green3: #5dc8ba;\n$green: #21ba72;\n$green0: #30BA9A;\n$green0-0_5: rgba(48, 186, 154, 0.50);\n$green4: #62BDCA;\n$darkGreen: #209f6d;\n$green2: #21a19a;\n$prGreen: #00809C;\n$lightBlue: #d8ebfe;\n$blue: #1358bf;\n$red: #ee505a;\n$red0_5: rgba(238, 80, 90, 0.5);\n$red1: #EC1B28;\n$beige: rgba(255, 205, 156, 0.6);\n$yellow: #FFE5CD;\n\n// gradients\n$defaultGradient: linear-gradient(\n                56.46deg,\n                #a4eedc -45.58%,\n                #5bcab5 19.1%,\n                #6baae4 100%\n);\n$gradientLight: linear-gradient(56.46deg, #A4EEDC -45.58%, #5BCAB5 19.1%, #6BAAE4 100%);\n$gradient2: linear-gradient(\n                270deg,\n                rgba(224, 241, 254, 0.4) 0%,\n                rgba(212, 248, 239, 0.4) 49.63%,\n                rgba(199, 247, 233, 0.4) 100%\n);\n$gradient3: linear-gradient(225deg, #eef181 0%, #92dd90 51.47%, #4de9cb 100%);\n$gradient4: linear-gradient(\n                270deg,\n                rgba(224, 241, 254, 0.3) 0%,\n                rgba(212, 248, 239, 0.3) 49.63%,\n                rgba(199, 247, 233, 0.3) 100%\n);\n$gradient5: linear-gradient(270deg, #E0F1FE 0%, #D4F8EF 49.63%, #C7F7E9 100%);\n$gradient6: linear-gradient(270deg, #E0F1FE 0%, #D4F8EF 49.63%, #C7F7E9 100%);\n$gradientPlaceholder: linear-gradient(90deg, rgba(255,255,255,0) -10%, rgba(255,255,255,1) 50%);\n$gradientPlaceholderDisabled: linear-gradient(90deg, rgb(163 224 219 / 18%) -10%, rgb(233 234 234) 50%);\n$boxShadowModal: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n$gradientDanger: linear-gradient(94.6deg, #FEA4A4 0.09%, #EE6767 100.09%);\n$gradientOrange: linear-gradient(91.58deg, #FFB973 0.03%, #FFA244 100.03%);\n$mainPageBackground: linear-gradient(180deg, rgba(255, 255, 255, 0) 61.86%, rgba(255, 255, 255, 0.8) 100%), radial-gradient(10.51% 41.68% at 32.4% 13.32%, rgba(33, 186, 114, 0.36) 0%, rgba(33, 186, 114, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */\n, radial-gradient(33.57% 117.61% at 63.33% -9.67%, rgba(90, 177, 255, 0.24) 0%, rgba(0, 135, 205, 0.24) 0.01%, rgba(0, 135, 205, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */\n, radial-gradient(19.56% 68.52% at -4.53% 77.65%, rgba(255, 224, 102, 0.3) 0%, rgba(255, 224, 102, 0) 100%), linear-gradient(90deg, rgba(66, 227, 180, 0.34) 0%, rgba(107, 234, 199, 0.34) 49.98%, rgba(155, 208, 254, 0.34) 100%), #FFFFFF;\n//  color vars\n$borderOpacityColor: rgba(214, 214, 215, 0.5);\n$boxShadowColor: rgba(0, 0, 0, 0.08);\n$footerColor: #f8fefc;\n$nonActiveText: $gray9;\n\n$primary: $green;\n$main: $white;\n$scrollBg: $halfGray;\n$scroll: $gray7;\n$scrollHover: $shadowGray;\n$editorMenuHover: $halfGray;\n$border: $gray5;\n\n$mainText: $black;\n$headText: $textGray;\n$smallText: $gray6;\n$tableSmallText: $gray4;\n$blockTitle: $black1;\n$calendarGradient: $gradient5;\n$chartActiveBg: $gradient3;\n$nonActiveElement: $gray8;\n\n$secondaryColor: $lightGray;\n$borderColor: $grayWhite;\n$tooltipBorder: $gray12;\n$tooltipShadow: $shadowGray2;\n$danger: $red;\n$serviceDanger: $red1;\n$mainBtnDanger: $gradientDanger;\n$action: $prGreen;\n$bgAction: lighten($lightGreen, 15%);\n$inputBorderColor: $shadowGray;\n$selectBorderColor: $gray10;\n$documentButton: $gray2;\n$tagBackground: $whiteGray;\n$cardShadow: $boxShadowModal;\n$textSelected: $lightBlue;\n$menuHover: $gradient5;\n$blockBg: $gray13;\n$toggleBg: $gradientLight;","$headerHeight: 70px;\n$formWidth: 416px;\n$horizontalPadding: 204px;\n$mainBorderRadius: 16px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid-row-2": `Select_grid-row-2__vqKEs`,
	"vm-20": `Select_vm-20__zzRX6`,
	"divider-0": `Select_divider-0__3cZTy`,
	"rel": `Select_rel__isPh1`,
	"flex": `Select_flex__8DDnx`,
	"jcc": `Select_jcc__D8hG4`,
	"wrapper": `Select_wrapper__2Cvke`,
	"wrapper_fullwidth": `Select_wrapper_fullwidth__ywQi3`,
	"select": `Select_select__0ysHQ`,
	"select_disabled": `Select_select_disabled__2iWFM`,
	"select__value": `Select_select__value__05k-l`,
	"select_short": `Select_select_short__r3vh9`,
	"select_invalid": `Select_select_invalid__LR0EQ`,
	"select_fullwidth": `Select_select_fullwidth__P1Jp+`,
	"select__value_active": `Select_select__value_active__nr5x0`,
	"select__arrow": `Select_select__arrow__ur+QJ`,
	"select__arrow_expanded": `Select_select__arrow_expanded__Cv179`,
	"select__options": `Select_select__options__Fu7zU`,
	"select__options_expanded": `Select_select__options_expanded__Rpi2a`,
	"select__option": `Select_select__option__SAE0G`,
	"select__option-text": `Select_select__option-text__tbioK`,
	"select__option_expanded": `Select_select__option_expanded__MxQdN`,
	"select__error": `Select_select__error__OOYM-`
};
export default ___CSS_LOADER_EXPORT___;
